import { createSlice } from '@reduxjs/toolkit';

const mapSlice = createSlice({
  name: 'map',
  initialState: {
    data: null
  },
  reducers: {
    setMapData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    }
  },
  extraReducers: () => {}
});

export const { setMapData } = mapSlice.actions;
export default mapSlice.reducer;
